// OUSTAZ.AI API client
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/oustaz`;

const qs = (params = {}) => {
  const parts = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`);
  return parts.length ? `?${parts.join('&')}` : '';
};

const get = (path, params) => axios.get(`${API}${path}${qs(params)}`).then((r) => r.data);
const post = (path, body) => axios.post(`${API}${path}`, body).then((r) => r.data);
const put = (path, body) => axios.put(`${API}${path}`, body).then((r) => r.data);
const patch = (path, body) => axios.patch(`${API}${path}`, body).then((r) => r.data);
const del = (path, params) => axios.delete(`${API}${path}${qs(params)}`).then((r) => r.data);

export const fileUrl = (url) => {
  if (!url) return '';
  return url.startsWith('http') ? url : `${process.env.REACT_APP_BACKEND_URL}${url}`;
};

export const oustazApi = {
  config: (organization_id) => get('/config', { organization_id }),
  contentTypes: () => get('/content-types'),
  classes: (organization_id) => get('/classes', { organization_id }),
  studentLessons: () => get('/student/lessons'),
  uploadPdf: (organization_id, formData) =>
    axios.post(`${API}/upload/pdf${qs({ organization_id })}`, formData).then((r) => r.data),
  uploadJson: (organization_id, formData) =>
    axios.post(`${API}/upload/json${qs({ organization_id })}`, formData).then((r) => r.data),
  // Book Resources
  uploadBook: (organization_id, formData, title) =>
    axios.post(`${API}/books/upload${qs({ organization_id, title })}`, formData).then((r) => r.data),
  listBooks: (organization_id) => get('/books', { organization_id }),
  getBook: (bookId) => get(`/books/${bookId}`),
  getBookChunks: (bookId, from_page, to_page) => get(`/books/${bookId}/chunks`, { from_page, to_page }),
  deleteBook: (bookId) => del(`/books/${bookId}`),
  reparseBook: (bookId, body) => post(`/books/${bookId}/reparse`, body),
  generateBookResource: (bookId, body) => post(`/books/${bookId}/generate`, body),
  publishGeneration: (genId) => post(`/generations/${genId}/publish`),
  getModels: (organization_id) => get('/models', { organization_id }),
  saveModels: (body) => put('/models', body),
  generate: (body) => post('/generate', body),
  getJob: (jobId) => get(`/jobs/${jobId}`),
  listGenerations: (organization_id) => get('/generations', { organization_id }),
  getGeneration: (genId) => get(`/generations/${genId}`),
  deleteGeneration: (genId) => del(`/generations/${genId}`),
  updateSharing: (genId, body) => put(`/generations/${genId}/sharing`, body),
  renameGeneration: (genId, title) => put(`/generations/${genId}/rename`, { title }),
  autoNameGenerations: (organization_id) => post(`/generations/auto-name${qs({ organization_id })}`),
  downloadUrl: (genId) => `${API}/generations/${genId}/download`,
  // admin prompts
  listPrompts: (organization_id) => get('/prompts', { organization_id }),
  updatePrompt: (contentType, body) => put(`/prompts/${contentType}`, body),
  resetPrompt: (contentType, organization_id) => post(`/prompts/${contentType}/reset${qs({ organization_id })}`),
  // AI Chat Assistant
  listChats: (organization_id) => get('/chats', { organization_id }),
  createChat: (body) => post('/chats', body),
  getChat: (chatId, organization_id) => get(`/chats/${chatId}`, { organization_id }),
  sendChatMessage: (chatId, body) => post(`/chats/${chatId}/message`, body),
  renameChat: (chatId, body) => patch(`/chats/${chatId}`, body),
  deleteChat: (chatId, organization_id) => del(`/chats/${chatId}`, { organization_id }),
};
